/* @flow */

import React from 'react';
import { Menu, Icon, Button } from 'semantic-ui-react';

type Props = {
  hasPrevious: boolean,
  hasNext: boolean,
  onPrevious: () => void,
  onNext: () => void,
};

const ResourcesPages = ({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
}: Props) => (
  <Menu pagination>
    <Menu.Item
      as={Button}
      type="button"
      disabled={!hasPrevious}
      onClick={onPrevious}
    >
      <Icon name="chevron left" />
    </Menu.Item>
    <Menu.Item as={Button} type="button" disabled={!hasNext} onClick={onNext}>
      <Icon name="chevron right" />
    </Menu.Item>
  </Menu>
);

export default ResourcesPages;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/components/ResourcesPager.js